<template>
  <div class="box">
    <div class="head-box">
      <b>考试</b> Check
    </div>
    <div v-if="joinList.length > 0" style="width:1200px;overflow: hidden;margin: 20px auto;">
      <div v-for="(item, index) in joinList" :key="index" style="width:350px;border:1px dashed #ccc;float:left;padding:10px;position: relative;">
        <h3>{{ item.projectName }}</h3>
        <img :src="item.image" style="width:60px;height:80px;border-radius:5px;float: left;"/>
        &ensp;&ensp; 姓名：{{ item.name }}<br/>
        &ensp;&ensp; 手机号码：{{ item.mobile }}<br/>
        &ensp;&ensp; 身份证号：{{ item.card }}<br/>
        &ensp;&ensp;<a-button size="small" type="primary" @click="toCheck(item)">开始答题</a-button>
        <!-- <span v-else style="color:green;"> 已完成作答√</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'ExaminSchedule',
  components: {
    Upload
  },
  data () {
    return {
      matchFun,
      joinList: []
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.examin.examinJoinList({pointId: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.joinList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    toCheck (item) {
      window.open('/ActivityAnswer?programId=' + this.$route.query.programId + '&id=' + item.pointId + '&joinId=' + item.id + '&projectId=' + item.projectId)
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 1200px;
  margin: 0 auto;
}
.head-box{
  font-size: 18px;
  color: black;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid rgb(235, 234, 234);
}
.table-header{
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #244e8f;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
}
.table-body{
    width: 100%;
    line-height: 50px;
    // background: #B01F24;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.header-list{
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color:white;
}
.flx-1{
    flex: 1;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
    border-right:1px solid #ccc;
    border-bottom:1px solid #ccc;
    height: 50px;
}
.body-list{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/ActivityCheck.vue